var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHalfleave(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.73893 4.1293C7.54759 4.19743 7.36093 4.27303 7.17893 4.3561M5.39743 5.5055C5.2388 5.64415 5.08651 5.7899 4.94103 5.9423M3.72233 7.6748C3.59166 7.93613 3.47803 8.2061 3.38143 8.4847M3.01113 10.3537C2.99573 10.626 2.99643 10.9039 3.01253 11.1762M3.39753 13.0655C3.49086 13.3268 3.59913 13.5812 3.72233 13.8285M4.88363 15.4994C5.05443 15.6828 5.23479 15.8569 5.42473 16.0216M7.04313 17.0835C7.3208 17.2175 7.60702 17.333 7.89993 17.4293M9.99993 17.7793C13.866 17.7793 16.9999 14.6454 16.9999 10.7793C16.9999 6.9132 13.866 3.7793 9.99993 3.7793",
    stroke: "#533F04",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99995 11.8291C10.2784 11.8291 10.5455 11.7185 10.7424 11.5216C10.9393 11.3247 11.05 11.0576 11.05 10.7791C11.05 10.5006 10.9393 10.2336 10.7424 10.0366C10.5455 9.83973 10.2784 9.7291 9.99995 9.7291M9.99995 11.8291C9.72147 11.8291 9.4544 11.7185 9.25749 11.5216C9.06058 11.3247 8.94995 11.0576 8.94995 10.7791C8.94995 10.5006 9.06058 10.2336 9.25749 10.0366C9.4544 9.83973 9.72147 9.7291 9.99995 9.7291M9.99995 11.8291V13.5791M9.99995 9.7291V6.5791",
    stroke: "#533F04",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHalfleave);
export default __webpack_public_path__ + "static/media/halfleave.65fdda2039f959eebfe0fe010b659fd8.svg";
export { ForwardRef as ReactComponent };